// src/poker/table/labels.js

export const ORANGE = "rgba(255,165,0,0.95)";
export const ORANGE_BORDER = "rgba(255,165,0,0.35)";
export const ORANGE_DIVIDER = "rgba(255,165,0,0.18)";

// Jedno miejsce na przełączenie języka w UI pokerka
export const POKER_UI_LANG = "en"; // "en" | "pl"

export const UI = {
  STACK: "Stack",
  COMMITTED: "Wkład",
  NO_VALUE: "—",
};

// Akcje – klucze trzymamy jako “canonical”: FOLD/CALL/CHECK/BET/RAISE/ALL_IN
export const ACTIONS = {
  en: {
    FOLD: "FOLD",
    CHECK: "CHECK",
    CALL: "CALL",
    BET: "BET",
    RAISE: "RAISE",
    ALL_IN: "ALL-IN",
  },
  pl: {
    FOLD: "PAS",
    CHECK: "CZEK",
    CALL: "WYRÓWNAJ",
    BET: "ZAKŁAD",
    RAISE: "PRZEBIJ",
    ALL_IN: "ALL-IN",
  },
};

// Normalizuje wejście typu "fold" / "Fold" / "CALL" / "allin"
export function normalizeActionKey(x) {
  const s = String(x || "").trim().toUpperCase();
  if (!s) return "";
  if (s === "ALLIN" || s === "ALL-IN") return "ALL_IN";
  return s;
}

export function actionText(actionType, lang = POKER_UI_LANG) {
  const key = normalizeActionKey(actionType);
  if (!key) return UI.NO_VALUE;
  const dict = ACTIONS[lang] || ACTIONS.en;
  return dict[key] || key; // fallback: pokazuje klucz, jak nie ma w słowniku
}
